export default __webpack_public_path__ + "static/media/Star_Dark_Score.18f24ffd.svg";